var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.666V7.33268C0.5 4.19018 0.5 2.61852 1.47667 1.64268C2.45333 0.666849 4.02417 0.666016 7.16667 0.666016H8.83333C11.9758 0.666016 13.5475 0.666016 14.5233 1.64268C15.4992 2.61935 15.5 4.19018 15.5 7.33268V10.666C15.5 13.8085 15.5 15.3802 14.5233 16.356C13.5467 17.3318 11.9758 17.3327 8.83333 17.3327H7.16667C4.02417 17.3327 2.4525 17.3327 1.47667 16.356C0.500833 15.3793 0.5 13.8085 0.5 10.666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44413 7.88917C8.32329 8.76833 9.48163 9.66167 9.48163 9.66167L11.0683 8.07417C11.0683 8.07417 10.175 6.91583 9.29663 6.03667C8.41663 5.15833 7.25829 4.26417 7.25829 4.26417L5.67163 5.85167C5.67163 5.85167 6.56496 7.01 7.44413 7.88917ZM7.44413 7.88917L4.66663 10.6667M11.3333 7.80917L9.21663 9.92583M7.52496 4L5.40829 6.11667M4.66663 14H11.3333",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.c36ed3bf006522b2ae0a4e23c5db3143.svg";
export { ForwardRef as ReactComponent };